import { Box } from '@material-ui/core';

const TabPanel = ({ value, index, children }) => (
  <Box role="tabpanel" hidden={value !== index}>
    {value === index && children}
  </Box>
);

export default TabPanel;
